
import Vue from 'vue';
import { Podcast as IPodcast, PodcastPrimaryCategory } from '@root/modules/podcast/types/podcast';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';
import Category from '@root/modules/podcast/components/fragments/Category.vue';
import Swiper from '@core/components/UI/swiper/Swiper.vue';
import isMobileView from '@root/common/utils/isMobileView';

interface Props {
  data: IPodcast[];
}

interface Data {
  isMobileView: boolean;
  limit: number;
  swiperOptions: Record<string, any>;
}

interface Computed {
  items: PodcastPrimaryCategory[];
}

export default Vue.extend<Data, unknown, Computed, Props>({
  components: {
    LinkHandler,
    Category,
    Swiper,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isMobileView: false,
      limit: 6,
      swiperOptions: {
        spaceBetween: 24,
        initialSlide: 0,
        autoplay: false,
        loop: false,
        slidesPerView: 2.5,
        slidesPerGroup: 1,
        pagination: {
          enabled: false,
        },
        navigation: {
          enabled: false,
        },
        scrollbar: {
          enabled: false,
        },
        simulateTouch: false,
        breakpoints: {
          768: {
            freeMode: false,
            slidesPerView: 4,
            slidesPerGroup: 4,
          },
          1230: {
            freeMode: false,
            slidesPerView: 6,
            slidesPerGroup: 6,
          },
        },
      },
    };
  },
  computed: {
    items() {
      const data = [...this.data];

      return data
        .map((item: IPodcast) => {
          return item.primaryCategory;
        })
        .slice(0, this.limit);
    },
  },
  mounted() {
    this.isMobileView = isMobileView();
  },
});
